<template>
  <tab-badge class="tab-badge-green" />
</template>

<script>
import tabBadge from './tabBadge'

export default {
    name: "tabBadgeGreen",
    components: {
        tabBadge
    },
}
</script>


<style scoped>
.tab-badge-green {
  background-color: #16825d;
}
</style>